import { NotificationContentBase, PivotExtDatasetLoadedNotification } from '../../services/api.services';
import { BasicNotification } from '../models/basic-notification';

export function pivotExtDatasetLoadedMapping(content: NotificationContentBase, time: string) {
    let pivotExtDatasetloaded = <PivotExtDatasetLoadedNotification>content;
    return <BasicNotification>{
        id: pivotExtDatasetloaded.id,
        iconUrl: pivotExtDatasetloaded.succesful ? "/assets/img/notification-icons/pivot-success.svg" : "/assets/img/notification-icons/pivot-warning.svg",
        pendingUrl: "/assets/img/notification-icons/pivot-grey.svg",
        color: pivotExtDatasetloaded.succesful ? "#6DD400" : "#F29100",
        headline: "Extended Dataset Load",
        title: pivotExtDatasetloaded.pivotName,
        message: pivotExtDatasetloaded.succesful ? "has completed successfully" : "has failed",
        buttons: [
            {
                label: "Edit",
                url: `visuals/${pivotExtDatasetloaded.id}`
            },
            {
                label: "View",
                url: `visuals/${pivotExtDatasetloaded.id}/view`
            }
        ],
        time: time
    };
}
